import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Registra un evento page_view en GA4 en cada cambio de ruta.
 *
 * Motivo: Brickshare es una SPA. gtag('config', ...) solo dispara UN
 * page_view en la carga inicial del bundle. Todas las navegaciones
 * posteriores (con react-router-dom) NO se registran automáticamente.
 * Este hook resuelve el problema.
 *
 * También ignora la primera ejecución para no duplicar el page_view
 * inicial que ya emite gtag('config').
 *
 * Se monta una única vez en <AppContent /> (apps/web/src/App.tsx).
 */
export const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    // pequeño delay para asegurar que document.title ya se ha
    // actualizado por react-helmet-async
    const timeoutId = window.setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 50);

    return () => window.clearTimeout(timeoutId);
  }, [location.pathname, location.search]);
};